import React from "react";
import { Flex, Text } from "rebass";
import { Link } from "react-router-dom";
import { FaQrcode } from "react-icons/fa";

import { ButtonOpenProvider, ProviderType } from "./Button";

interface IProps {
  type: "in" | "up",
}

export const SignInWith: React.FC<IProps> = ({ type }) => (
  <Flex justifyContent="space-between" alignItems="center">
    <ButtonOpenProvider type={type} providerType={ProviderType.google} />

    {
      type === "in" && (
        <Link
          to="/settings/qr"
          title="Sign in with QR code."
        >
          <Text as="span" color="#000">
            <FaQrcode size={40} display="block" />
          </Text>
        </Link>
      )
    }

    <ButtonOpenProvider type={type} providerType={ProviderType.facebook} />
  </Flex>
);
